export default __webpack_public_path__ + "static/media/lpbank_thumb.f02cb9ab.png";